
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/bddk-erisim-yonetimi",
      function () {
        return require("private-next-pages/solutions/bddk-erisim-yonetimi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/bddk-erisim-yonetimi"])
      });
    }
  